<!--
Add a clear cart button
Add cart total items in nav bar
Add Proceed to checkout at the bottom of restaurant menu
Make a price breakdown openable and closeable
-->
<template>
  <div class="my-cart">
    <Loading v-if="!this.allLoaded || this.placingOrder" />
    <CartAdditionalRequestModal
      v-if="additionalRequestsModal"
      :additionalRequests="additionalRequests"
      @close-modal="updateAdditionalRequests"
    />
    <Modal
      v-if="cartEmpty"
      :modalMessage="cartEmptyMessage"
      @close-modal="orderNowRoute"
    />
    <div class="cart-1" v-if="this.allLoaded">
      <div class="header">
        <h1>My Cart</h1>
        <p>You have {{ this.totalItems }} Item(s) in Cart!</p>
      </div>
      <div class="cart-items">
        <div class="restaurant-and-trash">
          <div class="restaurant-title">
            <h3>Restaurant: {{ this.restaurantDetails.name }}</h3>
            <h5>Location: {{ this.restaurantDetails.location }}</h5>
          </div>
          <div @click.prevent="resetCart" class="trash-icon">
            <TrashIcon class="icon" />
            <span>Empty Cart</span>
          </div>
        </div>
        <div class="items" v-if="mainCart">
          <!--
            <p>{{ this.mainCart }}</p>
                      <CartItemView :key="item" v-for="item in arrayIndexesForItems" />
            -->

          <CartItemView
            :key="item"
            v-for="item in arrayIndexesForItems"
            :itemIndex="item"
            :itemName="mainCart[item]"
            :itemValue="mainCart[item + 1]"
            :itemQuantity="mainCart[item + 2]"
            :mainCart="mainCart"
            @updateRequest="updateRequest"
            @update-cart="updateCart"
          />
        </div>
      </div>
      <div class="price-breakdown">
        <div class="total-price">
          <div class="description">Total Price</div>
          <div class="amount">S${{ this.totalPrice.toFixed(2) }}</div>
        </div>
        <p>Breakdown:</p>
        <div class="items-value">
          <div class="description">Item(s) Value</div>
          <div class="amount">S${{ this.itemsValue }}</div>
        </div>
        <div class="saviour-charges">
          <div class="description">Saviour Perk/Reward</div>
          <div class="amount">S${{ this.saviourPerk }}</div>
        </div>
        <div class="app-charges">
          <div class="description">App Charges</div>
          <div class="amount">S${{ this.appCharge }}</div>
        </div>
      </div>
    </div>
    <div class="cart-2" v-if="this.allLoaded">
      <div class="header">
        <h1>Location</h1>
      </div>
      <div class="map-view">
        <OrderNowMap />
      </div>
      <div class="location-details">
        <!--
        <h1>Delivery Address</h1>
        -->
        <div class="block-number-div">
          <label for="bn">Block Number</label>
          <br />
          <input
            id="bn"
            placeholder="Eg: Block 17"
            type="text"
            class="block-number"
            v-model="blockNumber"
          />
        </div>
        <div class="residence-name-div">
          <label for="rn">Residence Name(PGPR, UTown...)</label>
          <br />
          <input
            id="rn"
            placeholder="Eg: PGPR, UTown..."
            type="text"
            class="residence-name"
            v-model="residenceName"
          />
        </div>
        <div class="pin-code-div">
          <label for="pc">Pin Code</label>
          <br />
          <input
            id="pc"
            placeholder="Eg: 118425"
            type="number"
            class="pin-code"
            v-model="pinCode"
          />
        </div>
        <div v-if="addressNotFilled" class="error">
          <p>Please Fill In The Address!</p>
        </div>
      </div>
      <div class="checkout">
        <!--
        <p>Proceed to Checkout</p>
        
        
        -->
        <div class="text" @click.prevent="showAdditionalRequestsModal">
          <p>Addtional Request?</p>
        </div>
        <div class="proceed-button">
          <button @click.prevent="placeOrder" class="proceed">
            Place Order
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";
import CartItemView from "../components/CartItemView.vue";
import Loading from "../components/Loading";
import Modal from "../components/Modal";
import OrderNowMap from "../components/OrderNowMap";
import TrashIcon from "../assets/Icons/trash-regular.svg";
import CartAdditionalRequestModal from "../components/CartAdditionalRequestModal";

export default {
  name: "Cart",
  components: {
    CartItemView,
    OrderNowMap,
    Modal,
    Loading,
    TrashIcon,
    CartAdditionalRequestModal,
  },
  data() {
    return {
      mainCart: this.$store.state.profileCart,
      totalPrice: 0,
      totalItems: 0,
      restaurantDetails: this.$store.state.profileCartRestaurantSummary,
      allLoaded: false,
      saviourPerk: 0,
      appCharge: 0,
      itemsValue: 0,
      cartEmptyMessage:
        "Uh Oh! Your Cart Is Empty, And We Too Think You Should Add Something!",
      cartEmpty: false,
      blockNumber: null,
      residenceName: null,
      pinCode: null,
      address: null,
      placingOrder: false,
      addressNotFilled: false,
      additionalRequestsModal: false,
      additionalRequests: null,
    };
  },
  created() {
    this.mainCart = this.$store.state.profileCart;
    this.totalItems = this.$store.state.profileCartLength;
    this.restaurantDetails = this.$store.state.profileCartRestaurantSummary;
    /*
    console.log("Can Access mainCart @created: ", this.mainCart.length);
    console.log(
      "RESTAURANT DETAILS",
      this.$store.state.profileCartRestaurantSummary
    );
    console.log("ORDER DETAILS (mainCart): ", this.mainCart);
    console.log("ORDER DETAILS NAME: ", this.mainCart[1]);
    console.log("ORDER DETAILS PRICE: ", this.mainCart[2]);
    console.log("ORDER DETAILS QTY:", this.mainCart[3]);
    this.totalCalculator();
    */
    /*
    try {
      firebase.auth().onAuthStateChanged((user) => {
        this.$store.commit("updateUser", user);
        if (user) {
          this.$store.dispatch("getCurrentUser");
          console.log(this.$store.state.profileEmail);
        }
      });
      //this.arrayIndexesForItems();
      this.getRestaurantDetails();
      this.totalCalculator();
    } catch (error) {
      console.log("Slow Server");
      //setTimeout(this.callAllMethods, 2000);
    }
    */
  },
  async mounted() {
    /*
    try {
      await this.$store.dispatch("getCurrentUser");
    } catch (e) {
      console.log("SLOW SERVER");
    }
    */
    const dataBase = await db
      .collection("users")
      .doc(firebase.auth().currentUser.uid);
    const dbResults = await dataBase.get();

    // Try to get User Location if possible
    // Else leave for them or detect through Google Maps
    try {
      this.blockNumber = dbResults.data().blockNumber;
      this.residenceName = dbResults.data().residenceName;
      this.pinCode = dbResults.data().pinCode;
    } catch (error) {
      this.blockNumber = null;
      this.residenceName = null;
      this.pinCode = null;
    }

    this.mainCart = dbResults.data().cart;
    this.totalItems = dbResults.data().cart.length;

    if (dbResults.data().cart.length !== 0) {
      //this.getRestaurantDetails();
      const dataBaseRestaurant = await db
        .collection("restaurants")
        .doc(dbResults.data().cart[0]);
      const dbResultsRestaurant = await dataBaseRestaurant.get();
      this.restaurantDetails = {
        id: dbResultsRestaurant.id,
        name: dbResultsRestaurant.data().name,
        location: dbResultsRestaurant.data().location,
      };

      this.totalCalculator();
    } else {
      this.restaurantDetails = {
        id: null,
        name: null,
        location: null,
      };
      this.cartEmpty = true;
    }
    this.allLoaded = true;
  },
  computed: {
    arrayIndexesForItems() {
      console.log(
        "Can Access mainCart @arrayIndexesForItems: ",
        this.mainCart.length
      );
      //return [...Array(this.$store.state.profileCart.length)].map((_, i) => i);
      let array = [];
      for (let i = 1; i < this.mainCart.length; i += 3) {
        array.push(i);
      }
      console.log("Created Array of Length ", array.length);
      console.log("Created Array ", array);
      return array;
    },
  },
  methods: {
    // //new Method added "27/6/2021":for request on each food order
    // updateRequest(ref) {
    //   return;
    // },
    showAdditionalRequestsModal() {
      this.additionalRequestsModal = true;
    },
    updateAdditionalRequests(request) {
      this.additionalRequestsModal = false;
      this.additionalRequests = request;
      //console.log(this.additionalRequests);
    },
    async placeOrder() {
      // Placing the Loading Animation
      this.placingOrder = true;

      // Checking the fields are not empty
      if (!this.blockNumber || !this.residenceName || !this.pinCode) {
        console.log("Cannot Order, No Address Given!");
        this.addressNotFilled = true;
        this.placingOrder = false;
        return;
      }

      // Complete Address
      this.address =
        this.blockNumber + ", " + this.residenceName + ", " + this.pinCode;

      // Arrays to be pushed into the database
      let foodItems = [];
      let foodItemsQuantity = [];
      let foodItemsRemarks = [];

      // Adding the data to the above mentioned arrays
      for (let i = 1; i < this.mainCart.length; i = i + 3) {
        foodItems[foodItems.length] = this.mainCart[i];
        foodItemsQuantity[foodItemsQuantity.length] = this.mainCart[i + 2];
      }

      // Logging to check if all works well :)
      // console.log(foodItems, foodItemsQuantity);

      // Creating the new order data in databse
      const newOrder = await db.collection("orders").doc();

      // Pushing all that data in the database
      //additionalRequests: "WORKING ON FEATURE :)",
      await newOrder
        .set({
          acceptedBySaviour: false,
          additionalRequests: this.additionalRequests,
          cart: this.mainCart,
          cancelled: false,
          delivered: false,
          deliveryTime: 1,
          foodItems: foodItems,
          foodItemsQuantity: foodItemsQuantity,
          foodItemsRemarks: foodItemsRemarks,
          orderTime: firebase.firestore.FieldValue.serverTimestamp(),
          restaurantLocation: this.restaurantDetails.location,
          restaurantName: this.restaurantDetails.name,
          restaurantid: this.mainCart[0],
          saviourContact: null,
          saviourName: null,
          time: firebase.firestore.FieldValue.serverTimestamp(),
          totalPrice: this.totalPrice,
          itemsValue: this.itemsValue,
          saviourPerk: this.saviourPerk,
          appCharge: this.appCharge,
          userContact: this.$store.state.profilePhoneNumber,
          userLocation: this.address,
          userName:
            this.$store.state.profileFirstName +
            " " +
            this.$store.state.profileLastName,
          userid: this.$store.state.profileId,
          orderPlacedAtRestaurant: false,
          orderPickedFromRestaurant: false,
          enRouteToSave: false,
        })
        .catch((error) => {
          console.log("Cannot Place Order: ", error);
        });

      // Getting the new order details back so as to get the unique order id number
      const newOrderDetails = await newOrder.get();

      // Trying to update user details in database
      const userDatabase = await db
        .collection("users")
        .doc(this.$store.state.profileId);

      // Updating user details, rather adding these fields like order id in an array, and address details
      await userDatabase.update({
        orders: firebase.firestore.FieldValue.arrayUnion(newOrderDetails.id),
        blockNumber: this.blockNumber,
        residenceName: this.residenceName,
        pinCode: this.pinCode,
      });

      // Logging to ensure order is placed
      console.log("Order Placed!");
      // this.$toast("Your Order Was Placed Successfully")

      // Making the cart empty and updating the user cart
      this.emptyCart();

      // To stop/remove/un-display the loading animation
      this.placingOrder = false;

      // Taking user to the OrderSummary Page
      this.$router.push({ name: "OrderSummary" });
    },
    orderNowRoute() {
      this.$router.push({ name: "OrderNow" });
    },
    emptyCart() {
      this.mainCart = [];
      this.$store.state.profileCart = [];
      this.$store.dispatch("updateCart");
    },
    resetCart() {
      this.cartEmptyMessage =
        "Cart Has Been Emptied! How About We Fill It Again?";
      this.emptyCart();
      this.totalCalculator();
    },
    /*
    updateCart(itemToBeUpdated) {
      for (let i = 1; i < this.mainCart.length; i = i + 3) {
        if (this.mainCart[i] === itemToBeUpdated[0]) {
          if (itemToBeUpdated[2] === 0) {
            this.mainCart.splice(i, 3);
            if (this.mainCart.length === 1) {
              //this.mainCart = [];
              this.mainCart.splice(0, this.mainCart.length);
            }
          } else {
            this.mainCart[i + 2] = itemToBeUpdated[2];
          }
        }
      }
      //PUSH to DB
    },
    callAllMethods() {
      this.arrayIndexesForItems();
      //this.getRestaurantDetails();
      this.totalCalculator();
    },
    */
    /*
    async getRestaurantDetails() {
      const dataBase = await db
        .collection("restaurants")
        .doc(this.$store.state.profileCart[0]);
      const dbResults = await dataBase.get();
      this.restaurantDetails = {
        id: this.mainCart[0],
        name: dbResults.data().name,
        location: dbResults.data().location,
      };
      //commit("setProfileInfo", dbResults);
      //console.log(dbResults);
      this.allLoaded = true;
    },
    */
    updateCart(newCart) {
      this.mainCart = newCart;
      this.totalCalculator();
      /*
      const dataBase = await db
        .collection("users")
        .doc(this.$store.state.profileId);
      await dataBase.update({
        cart: this.mainCart,
      });
      */
    },
    totalCalculator() {
      console.log(
        "Can Access mainCart @totalCalculator: ",
        this.mainCart.length
      );
      if (this.mainCart.length === 0) {
        this.cartEmpty = true;
        this.totalItems = 0;
      }
      this.totalPrice = 0;
      for (let i = 1; i < this.mainCart.length; i += 3) {
        this.totalPrice += this.mainCart[i + 1] * this.mainCart[i + 2];
      }
      // Paying 10% of the total amount to Saviour, can be decided later on..
      this.itemsValue = this.totalPrice;
      this.saviourPerk = (this.totalPrice * 0.1).toFixed(2);
      this.totalPrice += this.totalPrice * 0.1;
      this.totalItems =
        this.mainCart.length === 0 ? 0 : (this.mainCart.length - 1) / 3;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-cart {
  display: flex;
  flex-direction: row;
  //height: 100vh;
  min-height: 100vh;

  @media (max-width: 800px) {
    flex-direction: column;
  }

  .cart-1 {
    //background-color: royalblue;
    flex-basis: 70%;
    display: flex;
    flex-direction: column;
    border-right: 7px solid #000;
    margin-right: 10px;
    padding-right: 10px;

    @media (max-width: 800px) {
      border-bottom: 7px solid #000;
      margin-bottom: 10px;
      padding-bottom: 10px;

      border-right: none;
      margin-right: 0;
      padding-right: 0;
    }

    .header {
      //background-color: skyblue;
      flex-basis: 10%;

      h1 {
        text-align: center;
        font-size: 50px;
      }

      p {
        font-size: 24px;
        padding-left: 7px;

        @media (max-width: 800px) {
          font-size: 18px;
        }
      }
    }

    .cart-items {
      //background-color: slateblue;
      background-color: #f1f1f1;
      flex-basis: 70%;
      display: flex;
      flex-direction: column;
      //overflow: scroll;
      max-height: 70vh;

      .restaurant-and-trash {
        flex-basis: 10%;
        display: flex;
        flex-direction: row;

        .restaurant-title {
          //border: 1px solid black;
          flex-basis: 85%;
          padding-left: 7px;

          h3 {
            font-size: 30px;
            margin-bottom: 5px;
          }

          h5 {
            font-size: 15px;
          }
        }

        .trash-icon {
          cursor: pointer;
          flex-basis: 15%;
          display: flex;
          align-self: center;
          color: #fff;
          font-size: 14px;
          padding: 8px 24px;
          border-radius: 8px;
          background-color: #303030;
          margin: 16px 5px 16px auto;
          text-align: center;
          text-transform: capitalize;
          max-height: 55px;

          .icon {
            width: 14px;
            height: auto;
            margin-right: 8px;

            @media (max-width: 800px) {
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }

      .items {
        overflow: scroll;
        flex-basis: 90%;
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
        //border: 1px solid red;
      }
    }

    .price-breakdown {
      //background-color: springgreen;
      flex-basis: 20%;
      //overflow: auto;
      //height: 730px;

      p {
        padding-left: 15px;
        padding-bottom: 15px;
        margin-top: 10px;
        font-size: 20px;

        @media (max-width: 800px) {
          font-size: 18px;
          padding-bottom: 10px;
          margin-top: 10px;
        }
      }

      .total-price {
        //height: 50px;
        font-size: 40px;
        display: flex;
        flex-direction: row;

        @media (max-width: 800px) {
          font-size: 30px;
        }

        .description {
          margin-right: auto;
          padding-left: 15px;
        }

        .amount {
          margin-left: auto;
          padding-right: 15px;
        }
      }

      .items-value {
        //height: 50px;
        font-size: 20px;
        display: flex;
        flex-direction: row;

        @media (max-width: 800px) {
          font-size: 18px;
        }

        .description {
          margin-right: auto;
          padding-left: 15px;
        }

        .amount {
          margin-left: auto;
          padding-right: 15px;
        }
      }

      .saviour-charges {
        //height: 50px;
        font-size: 20px;
        display: flex;
        flex-direction: row;

        @media (max-width: 800px) {
          font-size: 18px;
        }

        .description {
          margin-right: auto;
          padding-left: 15px;
        }

        .amount {
          margin-left: auto;
          padding-right: 15px;
        }
      }

      .app-charges {
        //height: 50px;
        font-size: 20px;
        display: flex;
        flex-direction: row;

        @media (max-width: 800px) {
          font-size: 18px;
        }

        .description {
          margin-right: auto;
          padding-left: 15px;
        }

        .amount {
          margin-left: auto;
          padding-right: 15px;
        }
      }
    }
  }

  .cart-2 {
    //background-color: sandybrown;
    flex-basis: 30%;
    display: flex;
    flex-direction: column;

    .header {
      //background-color: teal;

      flex-basis: 10%;

      h1 {
        text-align: center;
        font-size: 50px;
      }
    }

    .map-view {
      //background-color: yellow;
      //border: 2px solid violet;
      min-height: 300px;
      flex-basis: 50%;
    }

    .location-details {
      //background-color: thistle;
      flex-basis: 35%;
      display: flex;
      flex-direction: column;

      label {
        font-size: 18px;
        margin: 0 auto;
      }

      input {
        height: 50px;
        width: 280px;
        //width: 100%;
        //max-width: 350px;
        border: none;
        background-color: #f2f7f6;
        padding-left: 5px;

        &:focus {
          outline: none;
        }
      }

      .error {
        flex-basis: 1%;
        color: rgb(255, 18, 18);
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 5px;
      }

      .block-number-div {
        margin: 0 auto;
        flex-basis: 33%;
        text-align: center;

        .block-number {
        }
      }

      .residence-name-div {
        margin: 0 auto;
        flex-basis: 33%;
        text-align: center;

        .residence-name {
        }
      }

      .pin-code-div {
        margin: 0 auto;
        flex-basis: 33%;
        text-align: center;

        .pin-code {
        }
      }
    }

    .checkout {
      // background-color: tomato;
      flex-basis: 5%;
      display: flex;
      flex-direction: row;

      .text {
        //border: 3px solid red;
        background-color: #303030;
        //border-radius: 8px;
        flex-basis: 30%;
        display: flex;
        justify-content: center;
        cursor: pointer;
        text-align: center;
        align-items: center;
        transition: 0.28s;
        margin: 10px 0;

        @media (min-width: 800px) {
          margin: 0;
          margin-bottom: 7px;
        }

        &:hover {
          transition: 0.28s;
          background-color: #444444;
        }

        p {
          color: #fff;
          font-size: 15px;
        }
      }

      .proceed-button {
        //border: 3px solid blue;
        flex-basis: 100%;
        display: flex;
        justify-content: center;

        .proceed {
          background-color: rgb(255, 18, 18);
          border: 2px red solid;
          border-radius: 0;
          //cursor: pointer;
          margin: 10px 0;
          transition: 0.8s;

          @media (min-width: 800px) {
            margin: 0;
            margin-bottom: 7px;
          }

          &:hover {
            background-color: rgb(255, 72, 72);
            width: 100%;
            //height: 100%;
            transition: 0.8s;
          }
        }
      }
    }
  }
}
</style>
